import NotificationActions from '../../actions/NotificationActions';

import ConfirmPopup from '../common/ConfirmPopup.react';

class NoteFullscreen extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid(),
            showAdditionalInfo : false,
            confirmClose : false,
        };

        this.close = this.close.bind(this);
    }

    close(e) {
        var self = this;

        var uuid = this.state.uuid;
        var note = this.props.note;

        NotificationActions.removeNotification(self.props.note.uuid);
    }

    render() {
        var self = this;

        var note = this.props.note;

        return ([
            <div
                className='notification-screen'
                id='notification'>

                <div className='popup__content notification-screen__body'>

                        <div className='popup-header'>
                            NOTIFICATION

                            <div
                                className='popup-close'
                                onClick={this.close}>

                                <i className='fa fa-times' aria-hidden='true' />
                            </div>
                        </div>

                        <div
                            className='notification-screen__content'
                            dangerouslySetInnerHTML={{ __html: note.body }}>

                        </div>
                </div>
            </div>,

            ( this.state.showAdditionalInfo &&
                <div className='smokescreen smokescreen__transparent'>
                    <div className='popup'>

                        <div
                            className='popup__close'
                            onClick={() => { this.setState({ showAdditionalInfo : false }); }}
                            style={{'color':'#ffffff'}}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>

                        <div className='note__info'>

                            { Object.keys(note.additionalInfo).map(x => {
                                return (
                                    <div key={x}>
                                        <div className='note__info--header'>
                                            {x}
                                        </div>
                                        <div className='note__info--body'>
                                            {note.additionalInfo[x]}
                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                    </div>
                </div>
            ),

            <ConfirmPopup
                title='Discard or Show Detailed Info'
                confirmLabel='Discard'
                cancelLabel='Show Info'
                onCancel={() => { this.setState({ showAdditionalInfo : true }); }}
                onConfirm={() => { this.setState({ confirmClose : true }, () => { self.close(false); }); }}
                ref='ConfirmPopup' />
        ]);
    }
}

export default NoteFullscreen;


// WEBPACK FOOTER //
// ./ui_src/app/components/notification/NoteFullscreen.react.jsx